module.exports = __webpack_public_path__ + "static/img/factory_en.9c39a88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/factory_en.jpg
// module id = ClTf
// module chunks = 16